let username = localStorage.getItem("authUsername");

export const initialState = {
  user: { username: username || "" },
  getUserLoading: false,
  loading: false,
  register: {},
  forgotPasswordDetail: {},
  confirmStatus: "",
  passwordSubmitStatus: "",
  updateUserStatus: "",
  error: null,
  changePasswordError: null,
  changePasswordLoading: false,
  cognitoUser: {},
  loggedUser: {},
  referral: {},
  referralHistories: [],
  referralHistoriesLoading: false,
  referralHistoryNextTokens: { 1: null },
  referralHistoriesError: null,
  referralTransactions: [],
  referralTransactionNextTokens: { 1: null },
  referralTransactionsLoading: false,
  referralTransactionsError: null,
  emailLogin: {},
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_GET_USER":
      return {
        ...state,
        error: null,
        getUserLoading: true,
      };
    case "GET_USER_SUCCESS":
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
        getUserLoading: false,
      };
    case "GET_USER_ERROR":
      return {
        ...state,
        getUserLoading: false,
        error: action.error,
      };
    case "REQUEST_UPDATE_USER":
      return {
        ...state,
        updateUserStatus: "",
        error: null,
        loading: true,
      };
    case "UPDATE_USER_SUCCESS":
      return {
        ...state,
        updateUserStatus: action.payload,
        loading: false,
      };
    case "UPDATE_USER_ERROR":
      return {
        ...state,
        updateUserStatus: "",
        loading: false,
        error: action.error,
      };
    case "UPDATE_USER_NPWP_DRAFT":
      return {
        ...state,
        user: {
          ...state.user,
          npwpDraft: action.payload.npwpDraft,
          npwpDraftID: action.payload.npwpDraft.id,
        },
      };

    case "REQUEST_LOGIN":
      return {
        ...state,
        error: null,
        loading: true,
        cognitoUser: {},
      };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        user: action.payload,
        loading: false,
      };
    case "LOGIN_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
        cognitoUser: {},
      };
    case "REQUEST_CONFIRM_LOGIN":
      return {
        ...state,
        error: null,
        loading: true,
        loggedUser: {},
      };
    case "CONFIRM_LOGIN_SUCCESS":
      return {
        ...state,
        loggedUser: action.payload.loggedUser,
        loading: false,
        cognitoUser: {},
      };
    case "CONFIRM_LOGIN_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_AUTO_SIGN_IN":
      return {
        ...state,
        error: null,
        loading: true,
        loggedUser: {},
      };
    case "AUTO_SIGN_IN_SUCCESS":
      return {
        ...state,
        loading: false,
        loggedUser: action.payload.loggedUser,
      };
    case "AUTO_SIGN_IN_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_GET_EMAIL_CODE":
      return {
        ...state,
        error: null,
        loading: true,
        emailLogin: {},
      };
    case "GET_EMAIL_CODE_SUCCESS":
      return {
        ...state,
        emailLogin: action.payload.emailLogin,
        loading: false,
      };
    case "GET_EMAIL_CODE_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "COGNITO_LOGIN_SUCCESS":
      return {
        ...state,
        loading: false,
        cognitoUser: action.payload.cognitoUser,
      };
    case "REQUEST_REGISTER":
      return {
        ...state,
        error: null,
        loading: true,
      };
    case "REGISTER_SUCCESS":
      return {
        ...state,
        loading: false,
        register: action.payload,
      };
    case "REGISTER_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_CONFIRM_SIGNUP":
      return {
        ...state,
        confirmStatus: "",
        error: null,
        loading: true,
      };
    case "CONFIRM_SIGNUP_SUCCESS":
      return {
        ...state,
        loading: false,
        confirmStatus: action.payload,
      };
    case "CONFIRM_SIGNUP_ERROR":
      return {
        ...state,
        confirmStatus: "",
        loading: false,
        error: action.error,
      };
    case "REQUEST_RESEND_CODE":
      return {
        ...state,
        error: null,
        loading: true,
      };
    case "RESEND_CODE_SUCCESS":
      return {
        ...state,
        loading: false,
        register: {
          ...state.register,
          codeDeliveryDetails: action.payload,
        },
      };
    case "RESEND_CODE_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_FORGOT_PASSWORD":
      return {
        ...state,
        forgotPasswordDetail: {},
        error: null,
        loading: true,
      };
    case "FORGOT_PASSWORD_SUCCESS":
      return {
        ...state,
        loading: false,
        forgotPasswordDetail: {
          codeDeliveryDetails: action.payload.nextStep.codeDeliveryDetails,
        },
      };
    case "FORGOT_PASSWORD_ERROR":
      return {
        ...state,
        forgotPasswordDetail: {},
        loading: false,
        error: action.error,
      };
    case "REQUEST_PASSWORD_SUBMIT":
      return {
        ...state,
        passwordSubmitStatus: "",
        forgotPasswordDetail: {},
        error: null,
        loading: true,
      };
    case "PASSWORD_SUBMIT_SUCCESS":
      return {
        ...state,
        passwordSubmitStatus: "SUCCESS",
        loading: false,
      };
    case "PASSWORD_SUBMIT_ERROR":
      return {
        ...state,
        passwordSubmitStatus: "",
        loading: false,
        error: action.error,
      };
    case "REQUEST_CHANGE_PASSWORD":
      return {
        ...state,
        changePasswordStatus: "",
        changePasswordError: null,
        changePasswordLoading: true,
      };
    case "CHANGE_PASSWORD_SUCCESS":
      return {
        ...state,
        changePasswordStatus: action.payload,
        changePasswordLoading: false,
      };
    case "CHANGE_PASSWORD_ERROR":
      return {
        ...state,
        changePasswordStatus: "",
        changePasswordLoading: false,
        changePasswordError: action.error,
      };
    case "CONFIRM_CHANGE_PASSWORD":
      return {
        ...state,
        changePasswordStatus: "",
      };
    case "REQUEST_LOGOUT":
      return {
        ...state,
        error: null,
        loading: true,
      };
    case "LOGOUT_SUCCESS":
      return {
        ...state,
        loading: false,
        user: {},
      };
    case "LOGOUT_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_ADD_MAIN_BUSINESS":
      return {
        ...state,
        request: action.payload.request,
        mainBusinessStatus: "",
        error: null,
        loading: true,
      };
    case "SUCCESS_ADD_MAIN_BUSINESS":
      return {
        ...state,
        request: null,
        mainBusinessStatus: action.payload.mainBusinessID,
        user: action.payload?.mainBusiness?.id
          ? {
              ...state.user,
              mainBusinessID: action.payload.mainBusiness.id,
              mainBusiness: action.payload.mainBusiness,
            }
          : state.user,
        loading: false,
      };
    case "ERROR_ADD_MAIN_BUSINESS":
      return {
        ...state,
        request: null,
        loading: false,
        error: action.error,
      };
    case "CLEAR_NEW_MAIN_BUSINESS":
      return {
        ...state,
        mainBusinessStatus: "",
      };
    case "UPDATE_MAIN_BUSINESS":
      return {
        ...state,
        user:
          state.user?.mainBusiness?.id === action.payload.business?.id
            ? {
                ...state.user,
                mainBusiness: {
                  ...state.user.mainBusiness,
                  ...action.payload.business,
                },
              }
            : state.user,
      };
    case "REQUEST_GET_REFERRAL":
      return {
        ...state,
        request: action.payload.request,
        loading: true,
        referral: initialState.referral,
        error: null,
      };
    case "REQUEST_GET_REFERRAL_SUCCESS":
      return {
        ...state,
        request: null,
        loading: false,
        referral: action.payload.referral,
        user: {
          ...state.user,
          referralID: action.payload.referral.referralID,
          referral: action.payload.referral.referral,
        },
      };
    case "REQUEST_GET_REFERRAL_ERROR":
      return {
        ...state,
        request: null,
        loading: false,
        error: action.payload.error,
      };
    case "REQUEST_LIST_REFERRAL_HISTORY":
      return {
        ...state,
        request: action.payload.request,
        referralHistories: [],
        referralHistoriesLoading: true,
        referralHistoriesError: null,
        referralHistoryNextTokens:
          action.payload.page === 1
            ? initialState.referralHistoryNextTokens
            : state.referralHistoryNextTokens,
      };
    case "LIST_REFERRAL_HISTORY_SUCCESS":
      return {
        ...state,
        request: null,
        referralHistories: action.payload.items,
        referralHistoriesLoading: false,
        referralHistoryNextTokens: {
          ...state.referralHistoryNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "LIST_REFERRAL_HISTORY_ERROR":
      return {
        ...state,
        request: null,
        referralHistoriesLoading: false,
        referralHistoriesError: action.error,
      };
    case "REQUEST_LIST_TRANSACTION_POINT_REFERRAL":
      return {
        ...state,
        request: action.payload.request,
        referralTransactions: [],
        referralTransactionsLoading: true,
        referralTransactionsError: null,
        referralTransactionNextTokens:
          action.payload.page === 1
            ? initialState.referralTransactionNextTokens
            : state.referralTransactionNextTokens,
      };
    case "LIST_TRANSACTION_POINT_REFERRAL_SUCCESS":
      return {
        ...state,
        request: null,
        referralTransactions: action.payload.items,
        referralTransactionsLoading: false,
        referralTransactionNextTokens: {
          ...state.referralTransactionNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "LIST_TRANSACTION_POINT_REFERRAL_ERROR":
      return {
        ...state,
        request: null,
        referralTransactionsLoading: false,
        referralTransactionsError: action.error,
      };
    default:
      return state;
  }
};
